import React from 'react';
import styled, { css } from 'styled-components';
import { Button } from '~/components';
import { colors, weights } from '~/styles';

const Styled = {
  Nav: styled.div`
    align-self: center;
    display: flex;
    align-items: center;
    border-radius: 0.3125rem;
    border-color: ${colors.white};
    overflow: hidden;
    background: ${colors.white};
    margin-left: auto;
  `,

  Button: styled(Button)`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 1px;
    min-width: 5rem;
    height: 2rem;
    padding: 0 1rem;
    color: ${colors.grey40};
    background-color: ${colors.grey5};
    font-size: 0.75rem;
    font-weight: ${weights.black};
    letter-spacing: 0.0625rem;
    text-transform: uppercase;
    border-radius: 0;

    &:first-child {
      margin-left: 0;
    }

    &:hover {
      color: ${colors.grey40};
      background-color: ${colors.grey10};
    }

    ${({ $active }) =>
      $active &&
      css`
        color: ${colors.white};
        background-color: ${colors.primary};

        &:hover {
          color: ${colors.white};
          background-color: ${colors.accent};
        }
      `}
  `,
};

export default function TasksViewNav({ value, onChange }) {
  return (
    <Styled.Nav>
      <Styled.Button onClick={() => onChange('list')} $active={value === 'list'}>
        List
      </Styled.Button>
      <Styled.Button onClick={() => onChange('board')} $active={value === 'board'}>
        Board
      </Styled.Button>
      <Styled.Button onClick={() => onChange('gantt')} $active={value === 'gantt'}>
        Gantt
      </Styled.Button>
    </Styled.Nav>
  );
}
